import { ReactNode } from 'react';

import { makeAuditRoute as _makeAuditRoute } from '@gasbi/shared/web/Audit';

import {
  useGetAuditEntriesInfiniteQuery,
  useGetAuditEntryDetailsQuery,
} from '@/features/audit/auditApi';
import { AuditEntityTypeName } from '@/features/audit/types';
import { UserPermissionType } from '@/features/permissions';

import { useGetEntityTypeName, useWithTranslatedFields } from './hooks';

const payload = {
  useGetAuditEntryDetailsQuery,
  useGetAuditEntriesInfiniteQuery,
  useGetEntityTypeName,
  useWithTranslatedFields,
  showEntityNameOnCard: true,
  showOnlyChangedFields: true,
};

export const makeAuditRoute = (
  path: string | (() => string),
  element: ReactNode,
  permissions: UserPermissionType | UserPermissionType[] = [],
) => _makeAuditRoute(path, element, permissions, payload);

export const auditLinkTemplates = {
  [AuditEntityTypeName.CounterpartyEntity]: '..', // same as '../../ID'
  [AuditEntityTypeName.ContractEntity]: '../contracts/ID',
  [AuditEntityTypeName.ConsumptionObjectEntity]: '../consumption-objects/ID',
};
